import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/GlobalKpiCards.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
